import React from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { SocialAdVisual } from '../components/SocialAdVisual';
import { SocialAdVisual2 } from '../components/SocialAdVisual2';
export function LandingPage() {
  return <div className="min-h-screen bg-rewayz-surface0 font-sans" data-id="element-170">
      <main data-id="element-171">
        <HeroSection data-id="element-172" />
      </main>
    </div>;
}